import React from 'react';
import { FaPizzaSlice } from 'react-icons/fa';

import ProgressBar from '../../../components/ProgressBar';
import BRLMoneyFormat from '../../../utils/BRLMoneyFormat';
import handleNumberFormat from '../../../utils/handleNumberFormat';
import { PizzaSummary, pizzaGroupTotals } from '../dashboardDetailsPizzas';

import { Group, Toggle } from './styles';

interface PizzaGroupItemProps {
  summary: PizzaSummary;
  countProducts: number;
  color: string;
  onClick?: () => void;
}

const PizzaGroupItem: React.FC<PizzaGroupItemProps> = ({
  summary,
  countProducts,
  color,
  onClick,
}) => {
  const totals = pizzaGroupTotals(summary);
  const share = countProducts ? (totals.quantity / countProducts) * 100 : 0;

  return (
    <Group>
      <Toggle type="button" color={color} onClick={onClick}>
        <div className="wrapper">
          <div className="icon-container">
            <FaPizzaSlice size={26} color={color} />
          </div>
          <div className="info">
            <header>
              <strong>Pizzas</strong>
              <strong>
                {totals.total.toLocaleString('pt-BR', BRLMoneyFormat)}
              </strong>
            </header>
            <footer>
              <span>{handleNumberFormat(totals.quantity)} pizzas</span>
              <span>{share.toFixed(1)}%</span>
            </footer>
          </div>
        </div>
        <ProgressBar color={color} progress={share} className="progress-bar" />
      </Toggle>
    </Group>
  );
};

export default PizzaGroupItem;
